import { render } from "./appearance.vue?vue&type=template&id=66d8fc8a&scoped=true"
import script from "./appearance.vue?vue&type=script&lang=js"
export * from "./appearance.vue?vue&type=script&lang=js"

import "./appearance.vue?vue&type=style&index=0&id=66d8fc8a&lang=scss&scoped=true"

import exportComponent from "/Users/ns/Desktop/entwicklung/github/corpred_desk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66d8fc8a"]])

export default __exports__